import React from 'react';
export const Nav01DataSource = (t)=>({
  wrapper: { className: 'header0 home-page-wrapper' },
  page: { className: 'home-page' },
  logo: {
    className: 'header0-logo',
    children: 'https://www.bmr-oe.com/static/images/logo15.png',
  },
  Menu: {
    className: 'header0-menu',
    children: [
      {
        name: 'item~mf2eciqzkga',
        className: 'header0-item',
        children: {
          href: '/#',
          children: [
            {
              children: (
                <span>
                  <span>
                    <span>
                      <p>{t('zxx8cxoy_-fuhz5Kg90CH')}</p>
                    </span>
                  </span>
                </span>
              ),
              name: 'text',
            },
          ],
        },
      },
      {
        name: 'item0',
        className: 'header0-item',
        children: {
          href: '#',
          children: [
            {
              children: (
                <span>
                  <span>
                    <span>
                      <span>
                        <span>
                          <p>{t('hlF-IhelUALi5REofK1Ik')}</p>
                        </span>
                      </span>
                    </span>
                  </span>
                </span>
              ),
              name: 'text',
            },
          ],
        },
        subItem: [
          {
            name: 'sub0',
            className: 'item-sub',
            children: {
              className: 'item-sub-item',
              children: [
                {
                  name: 'image0',
                  className: 'item-image m9mfhrvs9sh-editor_css',
                  children:
                    'https://www.bmr-oe.com/static/images/ico-v2/强激光78.ico',
                },
                {
                  name: 'title',
                  className: 'item-title m8wyzpxxeu-editor_css',
                  children: (
                    <span>
                      <span>
                        <p>{t('Kt5XMmMs_0E_dU4f2ECWb')}</p>
                      </span>
                    </span>
                  ),
                },
              ],
              href: '/#/second1',
            },
          },
          {
            name: 'sub1',
            className: 'item-sub',
            children: {
              className: 'item-sub-item',
              children: [
                {
                  name: 'image0',
                  className: 'item-image m8x0fu3h09i-editor_css',
                  children:
                    'https://www.bmr-oe.com/static/images/ico-v2/通用双轴50.ico',
                },
                {
                  name: 'title',
                  className: 'item-title m8x0c7zgutn-editor_css',
                  children: (
                    <span>
                      <span>
                        <span>
                          <p>{t('Duviqu6viX0tuUj-J1KCT')}</p>
                        </span>
                      </span>
                    </span>
                  ),
                },
              ],
              href: '/#/second2',
            },
          },
          {
            name: 'sub~m8x12rhcd3r',
            className: 'item-sub',
            children: {
              className: 'item-sub-item',
              children: [
                {
                  name: 'image0',
                  className: 'item-image m8x0fu3h09i-editor_css',
                  children:
                    'https://www.bmr-oe.com/static/images/ico-v2/单轴50.ico',
                },
                {
                  name: 'title',
                  className: 'item-title m8x0c7zgutn-editor_css',
                  children: (
                    <span>
                      <span>
                        <span>
                          <span>
                            <p>{t('3zo1WQYMn1M2jwpjxpi8T')}</p>
                          </span>
                        </span>
                      </span>
                    </span>
                  ),
                },
              ],
              href: '/#/second3',
            },
          },
          {
            name: 'sub~m8x12unqvh',
            className: 'item-sub',
            children: {
              className: 'item-sub-item',
              children: [
                {
                  name: 'image0',
                  className: 'item-image m8x0fu3h09i-editor_css',
                  children:
                    'https://www.bmr-oe.com/static/images/ico-v2/摆扫镜30.ico',
                },
                {
                  name: 'title',
                  className: 'item-title m8x0c7zgutn-editor_css',
                  children: (
                    <span>
                      <span>
                        <span>
                          <span>
                            <span>
                              <span>
                                <span>
                                  <span>
                                    <p>{t('NzW_ayuUGQ462KP4YtGSf')}</p>
                                  </span>
                                </span>
                              </span>
                            </span>
                          </span>
                        </span>
                      </span>
                    </span>
                  ),
                },
              ],
              href: '/#/second4',
            },
          },
          {
            name: 'sub~m8x12vr6qz',
            className: 'item-sub',
            children: {
              className: 'item-sub-item',
              children: [
                {
                  name: 'image0',
                  className: 'item-image m8x0fu3h09i-editor_css',
                  children:
                    'https://www.bmr-oe.com/static/images/ico-v2/振镜6240.ico',
                },
                {
                  name: 'title',
                  className: 'item-title m8x0c7zgutn-editor_css',
                  children: (
                    <span>
                      <span>
                        <span>
                          <span>
                            <span>
                              <span>
                                <p>{t('IZoJ5lgmmJJaJqw8zb3j0')}</p>
                              </span>
                            </span>
                          </span>
                        </span>
                      </span>
                    </span>
                  ),
                },
              ],
              href: '/#/second5',
            },
          },
          {
            name: 'sub~m8x12wndado',
            className: 'item-sub',
            children: {
              className: 'item-sub-item',
              children: [
                {
                  name: 'image0',
                  className: 'item-image m8x0fu3h09i-editor_css',
                  children:
                    'https://www.bmr-oe.com/static/images/ico-v2/电调镜78.ico',
                },
                {
                  name: 'title',
                  className: 'item-title m8x0c7zgutn-editor_css',
                  children: (
                    <span>
                      <span>
                        <span>
                          <span>
                            <p>{t('SOStgG-9R6qwRBDW2ST5R')}</p>
                          </span>
                        </span>
                      </span>
                    </span>
                  ),
                },
              ],
              href: '/#/second6',
            },
          },
          {
            name: 'sub~m8x12xgznka',
            className: 'item-sub',
            children: {
              className: 'item-sub-item',
              children: [
                {
                  name: 'image0',
                  className: 'item-image m8x0fu3h09i-editor_css',
                  children:
                    'https://www.bmr-oe.com/static/images/ico-v2/电动镜127.ico',
                },
                {
                  name: 'title',
                  className: 'item-title m8x0c7zgutn-editor_css',
                  children: (
                    <span>
                      <span>
                        <span>
                          <span>
                            <span>
                              <p>{t('Geei7Bgk8CY6jlwz10rmu')}</p>
                            </span>
                          </span>
                        </span>
                      </span>
                    </span>
                  ),
                },
              ],
              href: '/#/second7',
            },
          },
          {
            name: 'sub~m8x12yp8s7o',
            className: 'item-sub m976jn6jedn-editor_css',
            children: {
              className: 'item-sub-item',
              children: [
                {
                  name: 'image0',
                  className: 'item-image m8x0fu3h09i-editor_css',
                  children:
                    'https://www.bmr-oe.com/static/images/ico-v2/激光通信20.ico',
                },
                {
                  name: 'title',
                  className: 'item-title m8x0c7zgutn-editor_css',
                  children: (
                    <span>
                      <span>
                        <span>
                          <span>
                            <span>
                              <span>
                                <span>
                                  <span>
                                    <span>
                                      <span>
                                        <span>
                                          <span>
                                            <p>{t('P-WLCmRLJL9HDK7VJ0L6I')}</p>
                                          </span>
                                        </span>
                                      </span>
                                    </span>
                                  </span>
                                </span>
                              </span>
                            </span>
                          </span>
                        </span>
                      </span>
                    </span>
                  ),
                },
              ],
              href: '/#/second8',
            },
          },
          {
            name: 'sub~m9mfjmjr4va',
            className: 'item-sub m976jn6jedn-editor_css',
            children: {
              className: 'item-sub-item',
              children: [
                {
                  name: 'image0',
                  className: 'item-image m8x0fu3h09i-editor_css',
                  children:
                    'https://www.bmr-oe.com/static/images/ico-v2/永磁同步75.ico',
                },
                {
                  name: 'title',
                  className: 'item-title m8x0c7zgutn-editor_css',
                  children: (
                    <span>
                      <span>
                        <span>
                          <span>
                            <span>
                              <span>
                                <span>
                                  <span>
                                    <span>
                                      <span>
                                        <span>
                                          <p>{t('yEreWxJGMXRz16ZhhViM5')}</p>
                                        </span>
                                      </span>
                                    </span>
                                  </span>
                                </span>
                              </span>
                            </span>
                          </span>
                        </span>
                      </span>
                    </span>
                  ),
                },
              ],
              href: '/#/second9',
            },
          },
        ],
      },
      {
        name: 'item1',
        className: 'header0-item',
        children: {
          href: '/#/fourth',
          children: [
            {
              children: (
                <span>
                  <span>
                    <span>
                      <span>
                        <p>{t('OYjLfgHoDwyGFMcUdRb4S')}</p>
                      </span>
                    </span>
                  </span>
                </span>
              ),
              name: 'text',
            },
          ],
        },
      },
      {
        name: 'item2',
        className: 'header0-item',
        children: {
          href: '/#/tenth',
          children: [
            {
              children: (
                <span>
                  <span>
                    <span>
                      <span>
                        <p>{t('L-gXSiDwEFE1m6eAiUUby')}</p>
                      </span>
                    </span>
                  </span>
                </span>
              ),
              name: 'text',
            },
          ],
        },
      },
      {
        name: 'item3',
        className: 'header0-item',
        children: {
          href: '/#/fifth',
          children: [
            {
              children: (
                <span>
                  <span>
                    <span>
                      <p>{t('AsKSjU5K0hrCK362FHItI')}</p>
                    </span>
                  </span>
                </span>
              ),
              name: 'text',
            },
          ],
        },
      },
      {
        name: 'item~m98pdg3g8rs',
        className: 'header0-item',
        children: {
          href: '/#/sixth',
          children: [
            {
              children: (
                <span>
                  <span>
                    <p>{t('eMlDcl2Vp467FqXtLwj5f')}</p>
                  </span>
                </span>
              ),
              name: 'text',
            },
          ],
        },
      },
    ],
  },
  mobileMenu: { className: 'header0-mobile-menu' },
});
export const Banner10DataSource = (t)=>({
  wrapper: { className: 'banner1 m8wmyqt62ma-editor_css' },
  BannerAnim: {
    children: [
      {
        name: 'elem0',
        BannerElement: { className: 'banner-user-elem' },
        textWrapper: { className: 'banner1-text-wrapper' },
        bg: { className: 'bg bg0 m8wmxqt4hsf-editor_css' },
        title: { className: 'banner1-title', children: '' },
        content: {
          className: 'banner1-content m8wt5yzvohu-editor_css',
          children: (
            <span>
              <span>
                <span>
                  <span>
                    <span>
                      <span>
                        <span>
                          <span>
                            <span>
                              <blockquote>
                                {t('GGYbUlHr9uQtrwceAGK1K')}
                              </blockquote>
                            </span>
                          </span>
                        </span>
                      </span>
                    </span>
                  </span>
                </span>
              </span>
            </span>
          ),
        },
        button: {
          className: 'banner1-button m8wtjvr1hjk-editor_css',
          children: (
            <span>
              <span>
                <p>
                  <br />
                </p>
              </span>
            </span>
          ),
        },
      },
      {
        name: 'elem2',
        BannerElement: { className: 'banner-user-elem' },
        textWrapper: { className: 'banner1-text-wrapper' },
        bg: { className: 'bg bg1 m96u0zciy-editor_css' },
        title: { className: 'banner1-title', children: '' },
        content: {
          className: 'banner1-content m96ve128cj-editor_css',
          children: (
            <span>
              <span>
                <span>
                  <span>
                    <span>
                      <span>
                        <span>
                          <p>{t('FD1ZBZiVh7CARfjO5icMH')}</p>
                          <p>{t('KBc-E53Uf3bg5Vz3cUv9D')}</p>
                        </span>
                      </span>
                    </span>
                  </span>
                </span>
              </span>
            </span>
          ),
        },
        button: {
          className: 'banner1-button m96u6oixptm-editor_css',
          children: (
            <span>
              <p>
                <br />
              </p>
            </span>
          ),
        },
      },
    ],
    autoPlay: true,
    type: ['across'],
    autoPlaySpeed: 5000,
  },
});
export const Content131DataSource = (t)=>({
  OverPack: {
    className: 'home-page-wrapper content13-wrapper m999dm48xhu-editor_css',
    playScale: 0.3,
  },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        children: (
          <span>
            <span>
              <span>
                <span>
                  <span>
                    <span>
                      <span>
                        <span>
                          <span>
                            <span>
                              <span>
                                <span>
                                  <span>
                                    <span>
                                      <span>
                                        <span>
                                          <span>
                                            <span>
                                              <span>
                                                <span>
                                                  <span>
                                                    <span>
                                                      <span>
                                                        <span>
                                                          <p>BMR5130</p>
                                                          <p>
                                                            {t('vebeH2eAkU6IOW_BaXy4N')}
                                                          </p>
                                                        </span>
                                                      </span>
                                                    </span>
                                                  </span>
                                                </span>
                                              </span>
                                            </span>
                                          </span>
                                        </span>
                                      </span>
                                    </span>
                                  </span>
                                </span>
                              </span>
                            </span>
                          </span>
                        </span>
                      </span>
                    </span>
                  </span>
                </span>
              </span>
            </span>
          </span>
        ),
        className: 'title-h1',
      },
      {
        name: 'image',
        children:
          'https://www.bmr-oe.com/static/images/bg/永磁同步125.png',
        className: 'title-image mf2akg2d0ue-editor_css',
      },
      {
        name: 'content2',
        children: (
          <span>
            <span>
              <span>
                <span>
                  <span>
                    <span>
                      <span>
                        <span>
                          <span>
                            <span>
                              <span>
                                <span>
                                  <span>
                                    <span>
                                      <span>
                                        <span>
                                          <span>
                                            <span>
                                              <span>
                                                <span>
                                                  <p>
                                                    {t('RgfTmj2nn9W_BU31mzPjv')}
                                                  </p>
                                                  <p>
                                                    {t('XYY4a8aeUjR-BzpLY2DwT')}
                                                  </p>
                                                  <p>
                                                    {t('8KRJ8FOMDwWs9OtwP649C')}
                                                  </p>
                                                  <p>
                                                    {t('3gmThnVew-ulLIoPp-cUt')}
                                                  </p>
                                                </span>
                                              </span>
                                            </span>
                                          </span>
                                        </span>
                                      </span>
                                    </span>
                                  </span>
                                </span>
                              </span>
                            </span>
                          </span>
                        </span>
                      </span>
                    </span>
                  </span>
                </span>
              </span>
            </span>
          </span>
        ),
        className: 'title-content m99a2icryqg-editor_css',
      },
    ],
  },
});
export const Pricing20DataSource = (t)=>({
  wrapper: {
    className: 'home-page-wrapper pricing2-wrapper m99abc95oi-editor_css',
  },
  page: { className: 'home-page pricing2 m99aa4fupkr-editor_css' },
  OverPack: {
    playScale: 0.3,
    className: 'pricing2-content-wrapper m99a9po213-editor_css',
  },
  titleWrapper: {
    className: 'pricing2-title-wrapper m99bw5368cl-editor_css',
    children: [
      {
        name: 'title',
        children: (
          <span>
            <p>{t('w_E8EJ8xUK6nrwECToyJo')}</p>
          </span>
        ),
        className: 'pricing2-title-h1 m99a49tp7i8-editor_css',
      },
    ],
  },
  Table: {
    name: 'tabsTitle',
    size: 'default',
    className:
      'pricing2-table m99a63ja4aq-editor_css m99a8j73b49-editor_css m99bf1xg1nh-editor_css',
    columns: {
      children: [
        {
          dataIndex: 'free',
          key: 'free',
          name: 'free',
          childWrapper: {
            className: 'pricing2-table-name-block',
            children: [
              {
                name: 'name',
                className: 'pricing2-table-name',
                children: (
                  <span>
                    <span>
                      <p>{t('VExDpNqnBcDU-QqxOjTDZ')}</p>
                    </span>
                  </span>
                ),
              },
            ],
          },
        },
        {
          dataIndex: 'basic',
          key: 'basic',
          name: 'basic',
          childWrapper: {
            className: 'pricing2-table-name-block',
            children: [
              {
                name: 'name',
                className: 'pricing2-table-name',
                children: (
                  <span>
                    <span>
                      <p>{t('6YipWzbDk7c1gc0TFAkLE')}</p>
                    </span>
                  </span>
                ),
              },
            ],
          },
        },
        {
          dataIndex: 'pro',
          key: 'pro',
          name: 'pro',
          childWrapper: {
            className: 'pricing2-table-name-block',
            children: [
              {
                name: 'name',
                className: 'pricing2-table-name',
                children: (
                  <span>
                    <span>
                      <span>
                        <span>
                          <p>{t('O0Kq8wIbqcjFOkRYT85pt')}</p>
                        </span>
                      </span>
                    </span>
                  </span>
                ),
              },
            ],
          },
        },
        {
          dataIndex: 'unlimited',
          key: 'unlimited',
          name: 'unlimited',
          childWrapper: {
            className: 'pricing2-table-name-block',
            children: [
              {
                name: 'name',
                className: 'pricing2-table-name',
                children: (
                  <span>
                    <span>
                      <p>{t('wl8kaDZ4qm35BLJYuDTCc')}</p>
                    </span>
                  </span>
                ),
              },
            ],
          },
        },
      ],
    },
    dataSource: {
      children: [
        {
          name: 'list0',
          children: [
            {
              children: (
                <span>
                  <span>
                    <span>
                      <span>
                        <p>1</p>
                      </span>
                    </span>
                  </span>
                </span>
              ),
              name: 'content0',
              className: 'pricing2-table-content m99bjttojeb-editor_css',
            },
            {
              children: (
                <span>
                  <span>
                    <p>{t('pQTohIO2r7a89x53EwCzd')}</p>
                  </span>
                </span>
              ),
              name: 'content1',
              className: 'pricing2-table-content m99bjqn06s-editor_css',
            },
            {
              children: (
                <span>
                  <span>
                    <p>{t('h7BIlgpiqbgP1r4rc-T-m')}</p>
                  </span>
                </span>
              ),
              name: 'content2',
              className: 'pricing2-table-content m99bjmk6316-editor_css',
            },
            {
              children: (
                <span>
                  <span>
                    <p>Ф130 mm</p>
                  </span>
                </span>
              ),
              name: 'content3',
              className: 'pricing2-table-content m99bjwmf1s8-editor_css',
            },
          ],
        },
        {
          name: 'list1',
          children: [
            {
              children: (
                <span>
                  <p>2</p>
                </span>
              ),
              name: 'content0',
              className: 'pricing2-table-content m99bkb1z7ws-editor_css',
            },
            {
              children: (
                <span>
                  <p>
                    <br />
                  </p>
                </span>
              ),
              name: 'content1',
              className: 'pricing2-table-content',
            },
            {
              children: (
                <span>
                  <span>
                    <p>{t('WA6abr0O3yz-m0ozjppJX')}</p>
                  </span>
                </span>
              ),
              name: 'content2',
              className: 'pricing2-table-content m99biypx1og-editor_css',
            },
            {
              children: (
                <span>
                  <span>
                    <p>40mm</p>
                  </span>
                </span>
              ),
              name: 'content3',
              className: 'pricing2-table-content m99afqi6x9a-editor_css',
            },
          ],
        },
        {
          name: 'list2',
          children: [
            {
              name: 'content0',
              children: (
                <span>
                  <p>3</p>
                </span>
              ),
              className: 'pricing2-table-content m99bkejdaur-editor_css',
            },
            {
              name: 'content1',
              children: (
                <span>
                  <p>
                    <br />
                  </p>
                </span>
              ),
              className: 'pricing2-table-content',
            },
            {
              name: 'content2',
              children: (
                <span>
                  <span>
                    <p>{t('36Wf1gCRwd0pCs8bgqdnu')}</p>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content m99bltgunb-editor_css',
            },
            {
              name: 'content3',
              children: (
                <span>
                  <span>
                    <p> 100mm</p>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content m99bjkp5yz-editor_css',
            },
          ],
        },
        {
          name: 'list3',
          children: [
            {
              children: (
                <span>
                  <p>4</p>
                </span>
              ),
              name: 'content0',
              className: 'pricing2-table-content m99bkhm8b3b-editor_css',
            },
            {
              name: 'content1',
              children: (
                <span>
                  <span>
                    <p>
                      <br />
                    </p>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content m99bl6p9nf-editor_css',
            },
            {
              name: 'content2',
              children: (
                <span>
                  <span>
                    <p>{t('Db85vCy-7UlmfT951OJVi')}</p>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content m99bm54unvo-editor_css',
            },
            {
              name: 'content3',
              children: (
                <span>
                  <span>
                    <p>2.3E-03 kg-m2</p>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content m99borf50f7-editor_css',
            },
          ],
        },
        {
          name: 'list4',
          children: [
            {
              name: 'content0',
              children: (
                <span>
                  <p>5</p>
                </span>
              ),
              className: 'pricing2-table-content m99bkkv0vl-editor_css',
            },
            {
              name: 'content1',
              children: (
                <span>
                  <span>
                    <span>
                      <p>
                        <br />
                      </p>
                    </span>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content',
            },
            {
              name: 'content2',
              children: (
                <span>
                  <span>
                    <p>{t('jIA4gXESLe_52gtPWy_sz')}</p>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content m99bmakhv9g-editor_css',
            },
            {
              name: 'content3',
              children: (
                <span>
                  <span>
                    <p>1.19kg</p>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content m99botxcyi-editor_css',
            },
          ],
        },
        {
          name: 'list5',
          children: [
            {
              name: 'content0',
              children: (
                <span>
                  <p>6</p>
                </span>
              ),
              className: 'pricing2-table-content m99bknwfipn-editor_css',
            },
            {
              name: 'content1',
              children: (
                <span>
                  <span>
                    <p>
                      {t('DjskpA4ow5hnJigtinKTR')}<br />
                    </p>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content m99bnta347-editor_css',
            },
            {
              name: 'content2',
              children: (
                <span>
                  <span>
                    <p>{t('lCiDjYMpXoF8PaWGNNViV')}</p>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content m99bmcmbc3p-editor_css',
            },
            {
              name: 'content3',
              children: (
                <span>
                  <span>
                    <p> 4.20N-m</p>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content m99bmhzwzwu-editor_css',
            },
          ],
        },
        {
          name: 'list~m9992qcqan',
          children: [
            {
              name: 'content0',
              children: (
                <span>
                  <span>
                    <p>7</p>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content m99bkqpz8xs-editor_css',
            },
            {
              name: 'content1',
              children: (
                <span>
                  <span>
                    <span>
                      <p>
                        <br />
                      </p>
                    </span>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content',
            },
            {
              name: 'content2',
              children: (
                <span>
                  <span>
                    <span>
                      <p>{t('yM8VIoM8pPeavgiV4EM2V')}</p>
                    </span>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content m99bmflz1ur-editor_css',
            },
            {
              name: 'content3',
              children: (
                <span>
                  <span>
                    <span>
                      <p> 25.45N-m</p>
                    </span>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content m99bp1b7c4n-editor_css',
            },
          ],
        },
        {
          name: 'list~m9995d9gi2j',
          children: [
            {
              name: 'content0',
              children: (
                <span>
                  <span>
                    <p>8</p>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content m99bkw8os8b-editor_css',
            },
            {
              name: 'content1',
              children: (
                <span>
                  <span>
                    <span>
                      <p>
                        <br />
                      </p>
                    </span>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content',
            },
            {
              name: 'content2',
              children: (
                <span>
                  <span>
                    <span>
                      <p>{t('Bs44CCZIjIL2oGIh1ekiy')}</p>
                    </span>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content m99bmikkli-editor_css',
            },
            {
              name: 'content3',
              children: (
                <span>
                  <span>
                    <span>
                      <p> 26.50 Arms</p>
                    </span>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content m99bpp70n5f-editor_css',
            },
          ],
        },
        {
          name: 'list~m9995e20r0n',
          children: [
            {
              name: 'content0',
              children: (
                <span>
                  <span>
                    <p>9</p>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content m99bkwrio7-editor_css',
            },
            {
              name: 'content1',
              children: (
                <span>
                  <span>
                    <span>
                      <p>
                        {t('YssohEqNgFuxAGUw406zZ')}<br />
                      </p>
                    </span>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content m99bl7ryoos-editor_css',
            },
            {
              name: 'content2',
              children: (
                <span>
                  <span>
                    <span>
                      <p>{t('89ielCit_FLE8ONIgSTbp')}</p>
                    </span>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content m99bl9cj9-editor_css',
            },
            {
              name: 'content3',
              children: (
                <span>
                  <span>
                    <span>
                      <p> +24V~+100V</p>
                    </span>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content m99bsnq4szi-editor_css',
            },
          ],
        },
        {
          name: 'list~m9995ewkw1m',
          children: [
            {
              name: 'content0',
              children: (
                <span>
                  <span>
                    <p>10</p>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content m99bkyuktdf-editor_css',
            },
            {
              name: 'content1',
              children: (
                <span>
                  <span>
                    <span>
                      <p>
                        <br />
                      </p>
                    </span>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content',
            },
            {
              name: 'content2',
              children: (
                <span>
                  <span>
                    <span>
                      <p> {t('gA4vxz8V4dtTjS-qdTUAI')}</p>
                    </span>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content m99bmokz5m7-editor_css',
            },
            {
              name: 'content3',
              children: (
                <span>
                  <span>
                    <span>
                      <p> 5W</p>
                    </span>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content m99bq7klifu-editor_css',
            },
          ],
        },
      ],
    },
  },
});
export const Content130DataSource = (t)=>({
  OverPack: {
    className: 'home-page-wrapper content13-wrapper m994rqea0y-editor_css',
    playScale: 0.3,
  },
  titleWrapper: {
    className: 'title-wrapper m99d35o3ufq-editor_css',
    children: [
      {
        name: 'image',
        children:
          'https://www.bmr-oe.com/static/images/size/永磁同步125.png',
        className: 'title-image m99d1c63x6g-editor_css',
      },
      {
        name: 'title',
        children: (
          <span>
            <span>
              <p>{t('OnnIpt-LkJw9OYGJK2D2J')}</p>
            </span>
          </span>
        ),
        className: 'title-h1 m994tqtqy6-editor_css',
      },
      {
        name: 'content',
        children: (
          <span>
            <span>
              <span>
                <p>{t('xgl5FpbERi4J2gi5AQ9bw')}</p>
              </span>
            </span>
          </span>
        ),
        className: 'title-content m99cy2eu9e9-editor_css',
      },
    ],
  },
});
export const Footer10DataSource = (t)=>({
  wrapper: { className: 'home-page-wrapper footer1-wrapper' },
  OverPack: { className: 'footer1', playScale: 0.2 },
  block: {
    className: 'home-page',
    gutter: 0,
    children: [
      {
        name: 'block0',
        xs: 24,
        md: 6,
        className: 'block',
        title: {
          className: 'logo',
          children:
            'https://www.bmr-oe.com/static/images/logo15.png',
        },
        childWrapper: {
          className: 'slogan',
          children: [
            {
              name: 'content0',
              children: (
                <span>
                  <p>{t('iXrrRLSL0wAyepJ8IxDWm')}</p>
                </span>
              ),
              className: 'm8frbj7scy-editor_css',
            },
          ],
        },
      },
      {
        name: 'block1',
        xs: 24,
        md: 6,
        className: 'block',
        title: { 
          children: (
            <span >
              <p>{t('YGpJpPXEbY6rgKze5zCHr')}</p>
            </span>
            ),
        },
        childWrapper: {
          children: [
            {
              name: 'link0',
              href: '/产品手册-V1.1.pdf',
              children: (
                <span>
                  <span>
                    <p>{t('yBcRY6eVRmP6g8QqakVO9')}</p>
                  </span>
                </span>
              ),
            },
            {
              name: 'link2',
              href: '/接口定义-V1.0.pdf',
              children: (
                <span>
                  <span>
                    <span>
                      <p>{t('9WvyFz29k0ScaxImWtWt4')}</p>
                    </span>
                  </span>
                </span>
              ),
            },
          ],
        },
      },
      {
        name: 'block2',
        xs: 24,
        md: 6,
        className: 'block',
        title: {
          children: (
            <span>
              <p>{t('aDUKld9AKlOt47isE-Csl')}</p>
            </span>
          ),
        },
        childWrapper: {
          children: [
            {
              href: '/#/eighth',
              name: 'link0',
              children: (
                <span>
                  <span>
                    <p>{t('_Yd3eAhjwC1g9DDR-9DKh')}</p>
                  </span>
                </span>
              ),
            },
            {
              href: '/#/ninth',
              name: 'link1',
              children: (
                <span>
                  <p>{t('DHxxr78Jn0G-psdt_qciY')}</p>
                </span>
              ),
            },
          ],
        },
      },
      {
        name: 'block3',
        xs: 24,
        md: 6,
        className: 'block',
        title: {
          children: (
            <span>
              <p>{t('rlKW_zrnt4-TPJYkMidbV')}</p>
            </span>
          ),
        },
        childWrapper: {
          children: [
            {
              href: '/#/seventh',
              name: 'link0',
              children: (
                <span>
                  <span>
                    <span>
                      <p>{t('g2BChr8-amhwNN9DMuTFz')}</p>
                    </span>
                  </span>
                </span>
              ),
            },
            {
              href: '/#/sixth',
              name: 'link1',
              children: (
                <span>
                  <span>
                    <span>
                      <p>{t('vWcMT_jF0NG1_qBuX52yK')}</p>
                    </span>
                  </span>
                </span>
              ),
            },
          ],
        },
      },
    ],
  },
  copyrightWrapper: { className: 'copyright-wrapper' },
  copyrightPage: { className: 'home-page' },
  copyright: {
    className: 'copyright',
    children: (
      <span>
        <span>{t('SC2XohQEPkbVUlX_ewyih')}</span>
      </span>
    ),
  },
});
